
import Vue from "vue";
import Register from "~/components/form/Register.vue";
import SsoAuth from "~/components/form/SsoAuth.vue";

export default Vue.extend({
  name: "registerPage",
  components: { Register, SsoAuth },
  data() {
    return {
      title: "Bikeflights.com | Bicycle Shipping Service For Cyclists",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
  methods: {
    confirmationMade() {
      this.$router.push("/youraccount");
    },
  },
});
